import React from 'react';
import $ from 'jquery';
import loader from '../../components/css/dark/img/loader.gif';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";

class Filter extends React.Component {

    constructor(props) {
        super(props);
        let sort_val = "All";

        if (localStorage.getItem('Select_Sort_Value') != "" && localStorage.getItem('Select_Sort_Value') != null && localStorage.getItem('Select_Sort_Value') != undefined) {
            sort_val = localStorage.getItem('Select_Sort_Value');
        }
        else {
            sort_val = this.props.FilterData[0]["select_sort_value"];
        }
        this.state = {
            wname: this.props.wholesaler_name,
            whname: this.props.whname,
            FilterJson: this.props.FilterData,
            sort_value: sort_val,
            loading: false,
            submitted: false,
            error: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.updatedateonfilterclick();
        var $head = $(".popup_inner").contents().find("head");
        $head.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
        
    }
    updatedateonfilterclick() {
        try {
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                $(document).ready(function () {
                    $('.first-one .form-control').val(localStorage.getItem('User_Start_Date'));
                });

            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                $(document).ready(function () {
                    $('.second-one .form-control').val(localStorage.getItem('User_End_Date'));
                });
            }
        }
        catch (error) {
        }
    }
    handleChange(e) {
        this.setState({ sort_value: e.target.value });
    }

    handleSubmit(e) {
        try {
           
            this.setState({ submitted: true });
            this.setState({ loading: true });
            var Sort_value = $('#sort_value').val();
            if (Sort_value == '' || Sort_value == null || Sort_value == undefined) {
                //this.setState({ error: "Please enter 'All' or any of your group number in name field" });
                this.setState({ loading: false });
                e.preventDefault();
                return false;
            }
            var Sort_Name = $('#Sort_Name').val();
            var Processor = $('#Processor').val();
           
            var Sort_Name_Text = $("#Sort_Name option[value='" + Sort_Name + "']").text();
            var Proc_Text = $("#Processor option[value='" + Processor + "']").text()
          
            this.SaveWholesalerFilter('wholesaler', this.props.wholesaler_name, Sort_Name, Sort_value, Processor, Sort_Name_Text, Proc_Text,e);
            //this.props.handlechangea(e);
            e.preventDefault();
        }
        catch (error) {
        }
    }
    SaveWholesalerFilter(u_type, u_name, role_type, role_name, processor, role_name_text, proc_text, e) {
    
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ u_type,u_name, role_type, role_name, processor })
        };
        return fetch(`/api/ws/Update_wholesaler_filter`, requestOptions)
            .then(this.handleResponse)
            .then(user => {
                try {
                    this.updatedateonfilterclick();
                    if (user) {
                        if (user.length > 0) {
                            if (user[0].status_code == "1") {
                                //window.location = window.origin;
                                let newDate = new Date();
                                localStorage.setItem('Filter_Last_Update_Time', newDate);
                                localStorage.setItem('Updated_Filter_Status', role_type + "_" + role_name + "_" + processor);
                                //let newDate = new Date();

                                localStorage.setItem('Select_Sort_Name', role_type + "_" + role_name_text);
                                localStorage.setItem('Select_Sort_Value', role_name);
                                localStorage.setItem('Select_Sort_Processor', processor + "_" + proc_text);
                                this.props.handlechangea(e);
                                this.setState({ loading: false });
                                $('#CloseFilter button').click()

                            }
                            else {
                                this.setState({ loading: false, error: user[0].status_message });
                            }
                        }
                        else {
                            this.setState({ loading: false, error: 'Please try after sometime' });
                        }
                    }
                    else {
                        this.setState({ loading: false, error: 'Please try after sometime' });
                    }
                }
                catch (error) {
                    this.setState({ loading: false, error: 'Please try after sometime' });
                }
             
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }

    render() {
        try {
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
        } catch (error) { }
        const { submitted, loading, sort_value, error } = this.state;
        return (
            <div className='popup wholealer-filter filter-new'>
                <div className='popup_inner'>
                    <h1 id="CloseFilter">{this.props.text}<button onClick={this.props.WhFilterclosePopup}>X</button></h1>
                    <form className="filterForm">
                        <div className="form-group">
                            <label>Filter Criteria</label>
                            <span className="down-arrow">
                                <select className="form-control" id="Sort_Name">
                                    {
                                        this.state.FilterJson != null ?
                                            this.state.FilterJson[0]["sort_by"].map((obj, index) => {
                                                if (localStorage.getItem('Select_Sort_Name') != "" && localStorage.getItem('Select_Sort_Name') != null && localStorage.getItem('Select_Sort_Name') != undefined) {
                                                    if (obj.id + '_' + obj.name == localStorage.getItem('Select_Sort_Name')) {
                                                        return <option selected value={obj.id}>{obj.name}</option>
                                                    } else {
                                                        return <option value={obj.id}>{obj.name}</option>
                                                    }
                                                }
                                                {
                                                    if (obj.id == this.state.FilterJson[0]["select_sort_name"][0].id)
                                                        return <option selected value={obj.id}>{obj.name}</option>
                                                    else
                                                        return <option value={obj.id}>{obj.name}</option>
                                                }
                                            }) : null
                                    }
                                </select>
                            </span>
                        </div>
                        <div className="form-group">
                            <label>Name</label>
                            {
                                /*
                                 
                            <input id="Sort_value" type="text" value={this.state.FilterJson[0]["select_sort_value"]} className="form-control" name="sort_value" onChange={this.handleChange} />
                                 */
                            }
                            <input type="text" id="sort_value" className="form-control userwidth" name="sort_value" value={this.state.sort_value} onChange={this.handleChange} />
                            {submitted && !sort_value &&
                                <div className="help-block all-enter">Please enter 'All' or any of your group number</div>
                            }
                        </div>
                        <span className="or">AND/OR</span>
                        <div className="form-group">
                            <label>Filter by Processor</label>
                            <span className="down-arrow">
                                <select className="form-control" id="Processor">
                                    {
                                        this.state.FilterJson != null ?
                                            this.state.FilterJson[0]["processor"].map((obj, index) => {
                                                if (localStorage.getItem('Select_Sort_Processor') != "" && localStorage.getItem('Select_Sort_Processor') != null && localStorage.getItem('Select_Sort_Processor') != undefined) {
                                                    if (obj.id+'_'+obj.name == localStorage.getItem('Select_Sort_Processor') ) {
                                                        return <option selected value={obj.id}>{obj.name}</option>
                                                    } else {
                                                        return <option value={obj.id}>{obj.name}</option>
                                                    }
                                                }
                                                else {
                                                    if (obj.id == this.state.FilterJson[0]["select_processor"][0].id) {
                                                        return <option selected value={obj.id}>{obj.name}</option>
                                                    } else {
                                                        return <option value={obj.id}>{obj.name}</option>
                                                    }
                                                }
                                            }) : null
                                    }
                                </select>
                            </span>
                        </div>
                        <div className="form-group">
                            <div className="pop-btn">
                                <button className="btn" onClick={this.handleSubmit} >Submit</button>
                            </div>
                        </div>
                        <div className="form-group">
                            {loading &&
                                <img className="filter-loader" src={loader} alt="loader" />
                            }
                        </div>
                        {error &&
                            <div className="Error filter-submit-error">{error}</div>
                        }
                    </form>
                </div>
            </div>
        );
    }
}


export default Filter;